import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';
import {
    createCandlestickTileRequestUid,
    toCandlestickRequestUid,
} from 'widgets/candlestickTile/api/CandlestickTileStreamRequest';
import {
    initialPriceStreamDataState,
    initialPriceStreamState,
    PriceStreamState,
    PriceTimeDataTimeSeriesItem,
} from 'widgets/candlestickTile/store/stream/PriceStreamState';
import {
    CandlestickTileDataElement,
    CandlestickTileTimeElement,
    CandlestickTileTimeSeriesElement,
} from 'widgets/candlestickTile/api/CandlestickTileElement';
import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils';
import streamMessagesReducer from 'utils/messages/StreamMessage';
import {
    StreamDisableRangeElement,
    StreamMessageElement,
} from 'communication/types/StreamElement';
import disableRangeReducer from 'widgets/store/disableRange/StreamDisableRangeDataState';
import { StreamElementType } from 'communication/types/StreamElementType';
import omitUndefined from 'utils/omitUndefined';
import { mapSessionBoundary } from 'utils/timeseries/TimeSeriesDisableRange';

const processCandlestickDataStreamElement = (
    element: CandlestickTileDataElement,
    nextState: PriceStreamState
) => {
    const nextDataState = nextState.data ?? { ...initialPriceStreamDataState };
    timeSeriesReducer(
        element as CandlestickTileTimeSeriesElement,
        nextDataState,
        mapToCandlestickTileDataTimeSeriesItemFromElement
    );
    streamMessagesReducer(element as StreamMessageElement, nextState);
    disableRangeReducer(element as StreamDisableRangeElement, nextDataState);
    if (element._c === StreamElementType.OrderStat) {
        nextDataState.orderStat = {
            previousNightClose: element.p,
            exchangeRate: element.x,
            tickSize: element.tickSize,
        };
    }
};

function mapToCandlestickTileDataTimeSeriesItemFromElement(
    element: CandlestickTileTimeElement
): PriceTimeDataTimeSeriesItem {
    return omitUndefined({
        open: element.o,
        high: element.h,
        low: element.l,
        close: element.c,
        volume: element.v,
        ...mapSessionBoundary(element),
    });
}

const selectPriceStreamedData = (state: State) =>
    selectStreamedDataState(state).priceTiles;

const buildPriceStreamSlice = () =>
    buildStreamedDataStreamSlice(
        'startPriceChartStream',
        initialPriceStreamState,
        selectPriceStreamedData,
        createCandlestickTileRequestUid,
        toCandlestickRequestUid,
        processCandlestickDataStreamElement
    );

const {
    reducer: priceStreamedDataReducer,
    selectors: priceStreamedDataSelectors,
} = buildPriceStreamSlice();

export { priceStreamedDataReducer, priceStreamedDataSelectors };
